import { createContext, useContext, useEffect, useReducer } from "react";
import collections from "./Data";
import reducer from "./Reducer";
const CardContext = createContext();



const CardProvider = ({ children }) => {
  const initialData = {
    topCollection: [],
    topCollectionCopy: [],
  };


  const [currentData, dispatch] = useReducer(reducer, initialData);

  useEffect(() => {
      dispatch({type : 'storeCollections' , payload : collections})
  } , [])

  const filterCollection = (value) => {
    return dispatch({type : 'filterCollection' , payload : value })
  }


  return <CardContext.Provider value={{...currentData , filterCollection}}>{children}</CardContext.Provider>;
};

const CardGlobal = () => {
  return useContext(CardContext);
};

export { CardGlobal, CardProvider };
